import { render, staticRenderFns } from "./ImageInteraction.vue?vue&type=template&id=0710d1f2&scoped=true&"
import script from "./ImageInteraction.vue?vue&type=script&lang=js&"
export * from "./ImageInteraction.vue?vue&type=script&lang=js&"
import style0 from "./ImageInteraction.vue?vue&type=style&index=0&id=0710d1f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710d1f2",
  null
  
)

export default component.exports